<template>
  <div>
    <t-row class="permissions-table-row">
      <t-column size="" class="permissions-table-row-header row-header-selector">All properties {{ `(${totalPropertiesCount})` }}</t-column>
      <t-column
          v-for="permittee in permissionsTablePermittees"
          :key="`all_properties_${permittee.client_id}`"
          size=""
          class="enable-all"
          :data-hover="`${permittee.client_id}`"
      >
        <row>
          <input
              :id="`enable_all_property_permissions_${permittee.client_id}`"
              type="checkbox"
              @input="toggleAllPermissionsFor(permittee)"
              :checked="allPermissionsEnabledFor(permittee)"
              :indeterminate.prop="somePermissionsEnabledFor(permittee)"
          >
          <label :for="`enable_all_property_permissions_${permittee.client_id}`">
            All
          </label>
        </row>
      </t-column>
      <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_header_${index}`" size="">
        <row>&nbsp;</row>
      </t-column>
    </t-row>
    <template v-for="property in selectedObjectModel.editablePropertiesAndPropertySections">
      <template v-if="property.permissionEditableProperties">
        <t-row class="has-actions permissions-table-row">
          <t-column size="" class="permissions-table-row-header collapsed">
            <button class="toggle-group collapsed row-header-selector"
              data-toggle="collapse"
              @click="resetScrollTrigger()"
              :href="`#toggle_permissions_${property.client_id}`"
              :data-target="`#toggle_permissions_${property.client_id}`"
              :aria-controls="`#toggle_permissions_${property.client_id}`"
              aria-expanded="false"
              :disabled="property.permissionEditableProperties.length == 0"
              :class="property.permissionEditableProperties.length == 0 ? 'disabled' : ''"
            >
              <div class="header-text">{{ property.defaultLabelTitle }}</div>
              <small class="small">{{ 'property' | pluralize(property.permissionEditableProperties.length) }}</small>
            </button>
          </t-column>

          <t-column
              v-for="permittee in permissionsTablePermittees"
              :key="`${property.client_id}_${permittee.client_id}`"
              size=""
          >
            <row v-if="property.permissionEditableProperties.length > 0">
              <input
                  :id="`edit_all_property_permissions_${property.client_id}_${permittee.client_id}`"
                  type="checkbox"
                  @input="toggleAllPermissionsFor(permittee, {propertySection: property})"
                  :checked="allPermissionsEnabledFor(permittee, {propertySection: property})"
                  :indeterminate.prop="somePermissionsEnabledFor(permittee, {propertySection: property})"
              >
              <label :for="`edit_all_property_permissions_${property.client_id}_${permittee.client_id}`">
                Edit
              </label>
            </row>
          </t-column>
          <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_cell_${index}`" size="">
            <row>&nbsp;</row>
          </t-column>
        </t-row>
        <div v-if="property.permissionEditableProperties.length > 0" :id="`toggle_permissions_${property.client_id}`" class="collapse" :key="`${property.client_id}-row`">
          <property-row
              v-for="sectionProperty in property.permissionEditableProperties"
              :key="sectionProperty.client_id"
              :property="sectionProperty"
          ></property-row>
        </div>
      </template>

      <property-row
          v-else
          :key="property.client_id"
          :property="property"
      ></property-row>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import selectedMixin from "../mixins/selectedMixin";
import objectModelPermissionMixin from '../mixins/object-model-permission-mixin';
import permissionTablePermitteesMixin from '../mixins/permission-table-permittees-mixin';
import PropertyRow from './view-permissions-section-workarea-table-property-row.vue';
import remainingColumnMixin from "../mixins/remaining-column-mixin";
import pluralizeable from "~/mixins/pluralizeable";
import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";
import {gsap} from "gsap";
// tslint:disable-next-line:no-submodule-imports
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ObjectModelPropertyCapability} from "~/models/objectModelProperties/objectModelPropertyCapability";

gsap.registerPlugin(ScrollTrigger);

export default Vue.extend({
  mixins: [
    selectedMixin,
    objectModelPermissionMixin,
    permissionTablePermitteesMixin,
    remainingColumnMixin,
    pluralizeable,
  ],
  components: {
    PropertyRow,
  },
  computed: {
    permissionType(): number {
      return ObjectModelPermissionType.Property;
    },
    totalPropertiesCount(): number {
      return this.selectedObjectModel.objectModelPropertiesArray.filter(property => property.can(ObjectModelPropertyCapability.permissionEditable)).length;
    },
  },
  methods: {
    resetScrollTrigger(): void {
      setTimeout(function(){ ScrollTrigger.refresh(); },500);
    }
  },
  mounted() {
    gsap.to("#panel-permissions .table-horizontal", {
      scrollTrigger: {
        id: "tableHeader",
        trigger: "#panel-permissions .table-header",
        pin: true,
        start: "top top",
        end: "bottom center",
        endTrigger: "#panel-permissions .table-horizontal",
        pinSpacing: false,
        scroller: "#panel-permissions .scroll-area",
      }
    })
  },
  destroyed() {
    ScrollTrigger.getById("tableHeader").kill(true);
  }
});
</script>